import React from 'react'

const CommentReactions = ({ reactions = [], currentUserId, onReact, onRemoveReaction }) => {
  if (!reactions || reactions.length === 0) {
    return <span className="text-gray-500 text-xs">No reactions yet</span>
  }

  // Group reactions by emoji
  const groupedReactions = reactions.reduce((acc, reaction) => {
    if (!acc[reaction.emoji]) acc[reaction.emoji] = []
    acc[reaction.emoji].push(reaction)
    return acc
  }, {})

  return (
    <div className="flex items-center gap-1 flex-wrap">
      {Object.entries(groupedReactions).map(([emoji, reactionList]) => {
        const userReacted = reactionList.some(r => r.user?._id === currentUserId)

        return (
          <ReactionButton
            key={emoji}
            emoji={emoji}
            count={reactionList.length}
            userReacted={userReacted}
            onClick={() => userReacted ? onRemoveReaction() : onReact(emoji)}
          />
        )
      })}
    </div>
  )
}

const ReactionButton = ({ emoji, count, userReacted, onClick }) => (
  <button
    onClick={onClick}
    className={`flex items-center gap-1 px-2 py-1 rounded-full text-xs transition-colors ${
      userReacted
        ? 'bg-blue-500/30 text-blue-300 border border-blue-400/50'
        : 'bg-white/5 text-gray-300 hover:bg-white/10'
    }`}
  >
    <span>{emoji}</span>
    <span className="text-xs">{count}</span>
  </button>
)

export default CommentReactions